// extracted by mini-css-extract-plugin
export default {"items":"DragDropItems_items__IipsL","items_isDraggingOver":"DragDropItems_items_isDraggingOver__KwRs7"};